import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Box, Grid } from '@mui/material'
import { useGET_studentsQuery } from 'redux/api/studentsApi'

import { PRIMARY_BLUE, PRIMARY_GRASS_GREEN, PRIMARY_LIGHT_BLUE, PRIMARY_LIGHT_GREEN, PRIMARY_LIGHT_YELLOW, PRIMARY_PINK, PRIMARY_TRANSPARENT_GREEN, PRIMARY_YELLOW } from 'utils/customizedTheme'
import BoxTitle from 'components/atoms/BoxTitle'
import StudentCard from '../students/studentCard'
import RtiTier from './RtiTier'
import _ from 'lodash'
import EarlyWarningCard from '../students/EarlyWarningCard'
import { Flag } from '@mui/icons-material'



const EarlyWarningsSlider: FC = () => {
  const { t } = useTranslation()
  const reduxKey = 'dashboard'
  
  const { data } = useGET_studentsQuery({page_size: 12, risk_gte: 1})

  let slides = null;

  try {
    slides = data && data.results.slice(0,3).map(s => <EarlyWarningCard student={s} step={1} key={s.id} />)
  } catch (error) {

  }
  return (
    <Box className="thick-border dashboard-rti"> { data && data.results && <>
      
            <Box sx={{  marginBottom: '20px' }}>
                <BoxTitle title={t('common.early-warnings')} icon={<Flag sx={{ color: 'red' }} />} />
            </Box>
          
            <Grid container rowSpacing={0} columnSpacing={0}>
              <Grid item xs={12}>
                <div style={{ overflowX: 'auto', padding: '10px' }}>
                  <div style={{ display: 'grid', gap: '40px', gridTemplateColumns: 'auto auto auto'}}>
                      {slides && slides.map(s => s)}
                  </div>
                </div>
              </Grid>
            </Grid>
    
     </>}
    </Box>
  )
}
export default EarlyWarningsSlider